/**
 * Created with IntelliJ IDEA.
 * User: dkoehler
 * Date: 05.09.12
 * Time: 11:52
 * To change this template use File | Settings | File Templates.
 */

import { ExternalLog } from "../externalLogging/ExternalLog";
import { SocketErrorLOFactory } from "../externalLogging/factories/SocketErrorLOFactory";
import { debug } from "../logging/debug";

// import DataEvent = createjs.DataEvent;
import Event = createjs.Event;
// import IOErrorEvent = createjs.IOErrorEvent;
// import SecurityErrorEvent = createjs.SecurityErrorEvent;
import TimerEvent = createjs.TimerEvent;
// import XMLSocket = createjs.XMLSocket;
// import Security = createjs.Security;
import { Timer } from "@goodgamestudios/createjs-utilities";

import { Signal } from "signals.js";

/**
 *
 * TODO: @HTML5 - we'll need a different approach for this feature. XMLSocket
 * and the policy file are inexistant.
 *
 * Performs a roundtrip time measurement between user pc and game server (by
 * requesting the policy file from the policy server once more) and sends this
 * value to tracking.  The policy server runs on the same IP as the actual game
 * server, but isn't so susceptible to performance drops due to heavy user
 * load, so the measured time should be mostly "uncontaminated" by other
 * factors than pure "message travel time".
 */
export class PolicyPingTest {
    public testIsFinished: Signal;

    private static TIMEOUT_TIME: number = 20000;
    private ip: string;
    private port: number;
    private blueBox: number;
    private zone: string;
    // private testSocket: XMLSocket;
    private testSocket: any;
    private delay: number;
    private delayTimer: Timer;

    private startTime: number;
    private endTime: number;

    private playerId: number;

    /**
     * Creates a new PolicyPingTest on the given IP and port, which is automatically
     * performed after <code>delay</code> milliseconds.
     * @param ip the IP of the server to "ping"
     * @param port the port of the server to "ping"
     * @param delay delay of execution in milliseconds
     *
     */
    constructor(ip: string, port: number, zone: string, blueBox: number, delay: number, playerId: number) {
        this.ip = ip;
        this.port = port;
        this.blueBox = blueBox;
        this.zone = zone;
        this.testIsFinished = new Signal();

        this.delay = delay;
        this.playerId = playerId;
    }

    public startTimer(): void {
        this.delayTimer = new Timer(this.delay, 1);
        this.delayTimer.addEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.startTest));
        this.delayTimer.start();
    }

    /**
     * inits the testSocket after delay is expired
     * @param e delay of execution in milliseconds
     *
     */
    private startTest(e: TimerEvent): void {
        this.disposeDelayTimer();

        // this.testSocket = new XMLSocket();
        // this.testSocket.timeout = PolicyPingTest.TIMEOUT_TIME;
        // this.testSocket.addEventListener(Event.CONNECT, this.bindFunction(this.handleConnect));
        // this.testSocket.addEventListener(DataEvent.DATA, this.bindFunction(this.handleData));
        // this.testSocket.addEventListener(IOErrorEvent.IO_ERROR, this.bindFunction(this.onIOError));
        // this.testSocket.addEventListener(SecurityErrorEvent.SECURITY_ERROR, this.bindFunction(this.onSecurityError));

        try {
            //force load PolicyFile to prevent SecurityErrorEvent
            // Security.loadPolicyFile("xmlsocket://" + this.ip + ":" + this.port);
            // this.testSocket.connect(this.ip, this.port);
        }
        catch (error) {
            debug("PolicyPingTest, startTest() -> SecurityError: " + error.message);
        }
    }

    private disposeDelayTimer(): void {
        if (this.delayTimer) {
            this.delayTimer.stop();
            this.delayTimer.removeEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.startTest));
            this.delayTimer = null;
        }
    }

    private handleConnect(event: Event): void {
        debug("successfully connected!");
        this.startTime = Date.now();
        // this.testSocket.send("<policy-file-request/>");
    }

    private handleData(event: any): void {
        if (event.data.indexOf("policy") != -1) {
            this.endTime = Date.now();
            let roundtripTime: number = this.endTime - this.startTime;

            debug("roundtrip time measured:" + roundtripTime + " ms");

            this.dispatchResults(roundtripTime);

            this.closeConnection();
            this.removeSocketListeners();
        }
    }

    private dispatchResults(roundtripTime: number): void {
        this.testIsFinished.dispatch(this.delay, roundtripTime, this.blueBox);
    }

    private onIOError(event: any): void {
        debug("IO error:" + event.text);
        ExternalLog.logger.log(new SocketErrorLOFactory(SocketErrorLOFactory.POLICY_PING_TEST_IO_ERROR, this.ip, this.port, this.zone, event.text, this.blueBox));
        this.removeSocketListeners();
    }

    private onSecurityError(event: any): void {
        debug(" security error:" + event.text);
        ExternalLog.logger.log(new SocketErrorLOFactory(SocketErrorLOFactory.POLICY_PING_TEST_SECURITY_ERROR, this.ip, this.port, this.zone, event.text, this.blueBox));
        this.removeSocketListeners();
    }

    private closeConnection(): void {
        debug("connection closed");
        // this.testSocket.close();
    }

    private removeSocketListeners(): void {
        if (this.testSocket) {
            // this.testSocket.removeEventListener(Event.CONNECT, this.bindFunction(this.handleConnect));
            // this.testSocket.removeEventListener(DataEvent.DATA, this.bindFunction(this.handleData));
            // this.testSocket.removeEventListener(IOErrorEvent.IO_ERROR, this.bindFunction(this.onIOError));
            // this.testSocket.removeEventListener(SecurityErrorEvent.SECURITY_ERROR, this.bindFunction(this.onSecurityError));
            // this.testSocket = null;
        }

        if (this.testIsFinished) {
            this.testIsFinished.removeAll();
            this.testIsFinished = null;
        }
    }

    public dispose(): void {
        this.disposeDelayTimer();
        this.removeSocketListeners()
    }
}
